"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getpomailmessages = exports.updatepostatus = exports.activateDistributor = exports.deleteDistributor = exports.listtemplate = exports.listrules = exports.listsiteComapnyDetails = exports.listsitedistributors = exports.listdistributorinventory = exports.listdistributorinventoriescart = exports.listdistributorinventoriesbyinventoryid = exports.listinventorygroups = exports.listdistributorinventoriesbysite = exports.listdistributorinventories = exports.checkdeleteddistributors = exports.listdeleteddistributors = exports.listdistributors = exports.savedistributorinventories = exports.createtemplate = exports.removenotificationmethod = exports.addnotificationmethod = exports.deleterule = exports.saverule = exports.createrule = exports.updatedistributor = exports.listpurchaseorders = exports.updatepurchaseorderintents = exports.loadpurchaseorderintents = exports.updateassetsdescriptions = exports.listpurchaseorder = exports.listwithindaterange = exports.updatepurchaseorder = exports.createbackorder = exports.updateexpectedbackorderdate = exports.createpurchaseorder = exports.sendemailordertodistributor = exports.sendemailalert = exports.createdistributor = exports.listinvoices = exports.deleteinvoicedocument = exports.cancelpoinventory = exports.findinventorysite = exports.listordertrackingcreditdetails = exports.listordertrackingdetails = exports.listavailabledistributors = exports.addordertrackingcreditdetail = exports.addordertrackingdetail = exports.saveordertrackingdetails = exports.uploadinvoice = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.uploadinvoice = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "order/uploadinvoice",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.saveordertrackingdetails = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/saveordertrackingdetail",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.addordertrackingdetail = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/addordertrackingdetail",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.addordertrackingcreditdetail = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/addordertrackingcreditdetail",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listavailabledistributors = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listavailabledistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listordertrackingdetails = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listordertrackingdetails",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listordertrackingcreditdetails = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listordertrackingcreditdetails",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.findinventorysite = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/findinventorysite",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.cancelpoinventory = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/cancelpoinventory",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.deleteinvoicedocument = endpoint_1.createEndpoint()({
    method: "put",
    path: "order/deleteinvoicedocument",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listinvoices = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listinvoices",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.createdistributor = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/createdistributor",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.sendemailalert = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/sendemailalert",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.sendemailordertodistributor = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/sendemailordertodistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.createpurchaseorder = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/createpurchaseorder",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updateexpectedbackorderdate = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/updateexpectedbackorderdate",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.createbackorder = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/createbackorder",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updatepurchaseorder = endpoint_1.createEndpoint()({
    method: "put",
    path: "inventoryorder/updatepurchaseorder",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listwithindaterange = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listwithindaterange",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listpurchaseorder = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listpurchaseorder",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    tokens: { id: "number.required" }
});
exports.updateassetsdescriptions = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/updateassetsdescriptions",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.loadpurchaseorderintents = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/loadpurchaseorderintent",
    // tokens: { id: "number.required" },
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updatepurchaseorderintents = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/updatepurchaseorderintent",
    // tokens: { id: "number.required" },
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listpurchaseorders = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listpurchaseorders",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updatedistributor = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/updatedistributor",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.createrule = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/createrule",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE
});
exports.saverule = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/saverulerule",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE
});
exports.deleterule = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/deleterule",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE
});
exports.addnotificationmethod = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/addnotificationmethod",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE
});
exports.removenotificationmethod = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/removenotificationmethod",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE
});
exports.createtemplate = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/createtemplate",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE
});
exports.savedistributorinventories = endpoint_1.createEndpoint()({
    method: "put",
    path: "inventoryorder/savedistributorinventories",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_UPDATE
});
// C-097_Distributors
exports.listdistributors = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listdistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
// C-097_Distributor_UAT Disable 
// export const listdeleteddistributors = createEndpoint<never,{ distributors: any[]; success: boolean }>()({
exports.listdeleteddistributors = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listdeleteddistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.checkdeleteddistributors = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/ceckdeleteddistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.listdistributorinventories = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/listdistributorinventories",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.listdistributorinventoriesbysite = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listdistributorinventoriesbysite",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.listinventorygroups = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listinventorygroups",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.listdistributorinventoriesbyinventoryid = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/listdistributorbyinventoryid",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.listdistributorinventoriescart = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/listdistributorinventoriescart",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
//Update to Where Pop Up is Associated C-046.20611 
//2025-04-08 16:30:21
exports.listdistributorinventory = endpoint_1.createEndpoint()({
    method: "post",
    path: "inventoryorder/listdistributorWithSites",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.listsitedistributors = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listsitedistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
// D-023
exports.listsiteComapnyDetails = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listsiteComapnyDetails",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listrules = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listrules",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.listtemplate = endpoint_1.createEndpoint()({
    method: "get",
    path: "inventoryorder/listtemplates",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ
});
exports.deleteDistributor = endpoint_1.createEndpoint()({
    method: "put",
    path: "inventoryorder/deletedistributor",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_DELETE
});
exports.activateDistributor = endpoint_1.createEndpoint()({
    method: "put",
    path: "inventoryorder/activatedistributor",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_DELETE
});
exports.updatepostatus = endpoint_1.createEndpoint()({
    method: "put",
    path: "inventoryorder/updatepostatus",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.getpomailmessages = endpoint_1.createEndpoint()({
    method: "put",
    path: "inventoryorder/getpomailmessages",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});



//////////////////
// WEBPACK FOOTER
// ./src/api/inventory-order/inventory-order-client.ts
// module id = 988
// module chunks = 0 1 2